const getActiveStoreOffers = (availableProductCategories = [], storeProductCategories) => {
  const enabledPerStore = storeProductCategories?.map(({ code }) => code);
  return availableProductCategories.filter(({ key }) => enabledPerStore?.includes(key)).map(({ title, description, image, link }) => ({
    title,
    description,
    url: link,
    imageUrl: image?.url
  }));
};
export {
  getActiveStoreOffers
};
//# sourceMappingURL=get-active-store-offers.js.map
